export default "__VITE_ASSET__Cr35ng3Z__"